import { keepPreviousData } from "@tanstack/react-query";
import { $api } from "../generated/client";

/** What the Baback team did on the shop, newest first (BAB-3035). */
export function useSuperAdminAccessLogs(params: {
  shopId: string;
  limit: number;
  skip: number;
  /** The route answers 403 below ADMIN: skip it for anyone else. */
  isEnabled: boolean;
}) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/super-admin-access-logs",
    {
      params: {
        path: { shopId: params.shopId },
        query: { limit: params.limit, skip: params.skip },
      },
    },
    { placeholderData: keepPreviousData, enabled: params.isEnabled },
  );
}
